<template>
  <div class="MyCollection">

     <el-menu :default-active="activeIndex" class="el-menu-demo main" mode="horizontal" @select="handleSelect">
        <!--   -->
        <el-menu-item index="7">课程（{{countlist.coursecount}}）</el-menu-item>
        <el-menu-item index="8">题库（{{countlist.bankcount}}）</el-menu-item>
        <el-menu-item index="2">报告（{{countlist.reportcount}}）</el-menu-item>
        <el-menu-item index="13">活动（{{countlist.eventcount}}）</el-menu-item>
      </el-menu>


    <template v-if="myCollectionLists && myCollectionLists.length == 0">
        <div class="null">
          <img src="../../../../common/images/search/search-null.png" alt="">
          <p>当前暂无收藏的课程</p>
        </div>
      </template>
      <template v-else>
        <div class="main">
            <el-table :data="myCollectionLists" style="width: 100%">
            <el-table-column label="课程信息">
              <template slot-scope="scope">
                <div class="courses-card" @click="gotoRouterDetaills(scope.row.kmctype, scope.row.innerid)">
                    <div class="img"><img v-lazy="scope.row.coverurl" :alt="scope.row.subject"></div>
                    <div class="msg">
                      <p class="text-overflow">{{scope.row.subject}}</p>
                        <template v-if="scope.row.kmctype!=13">
                            <p class="money" v-if="scope.row.feetype == 1">免费</p>
                            <p class="money" v-else>{{scope.row.uprice}}</p>
                        </template>
                        <template v-else>
                            <p class="money" v-if="scope.row.minprice == 0.00&&scope.row.maxprice == 0.00">免费</p>
                            <p class="money" v-if="scope.row.minprice==scope.row.maxprice">￥{{scope.row.maxprice}}</p>
                            <p class="money" v-else>{{scope.row.priceinterval}}</p>
                        </template>
                    </div>
                  </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="right">
              <template slot-scope="scope">
                 <div class="position">
                  <span @click='canceluploadCourseFavorite(scope.row.innerid, scope.row.kmctype)'>取消收藏</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="prev, pager, next" :current-page.sync='myCollectionApi.page'  @current-change="handleCurrentChange" :total="rowCount"> </el-pagination>
        </div>
      </template>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import {uploadCourseFavorite} from 'api/public'
import {getMyCollectlist} from 'api/personalCenterApi'
export default {
  name: 'MyCollection',
  data () {
    return {
      myCollectionLists: [], // 课程列表
      myCollectionApi: {page: 1, pageSize: 10, kmctype: '7'},  // 接口api
      rowCount: 1, // 列表总数
      countlist: {}, // 数量统计
      activeIndex: '7' // 菜单
    }
  },
  mounted () {
    this.getMyCollectlists(1)
  },
  methods: {
    handleSelect(val) {  // 菜单栏发生切换
      this.myCollectionApi.kmctype = val
      this.getMyCollectlists(1)
    },
    getMyCollectlists(page) { // 收藏列表接口
      this.myCollectionApi.page = page
      this.setLoading(true)
      getMyCollectlist({
        data: this.myCollectionApi,
        success: data => {
          this.setLoading(false)
          this.myCollectionLists = data.data.content
          this.rowCount = data.data.pageinfo.rowCount
          this.countlist = data.data.countlist[0]
        },
        error: data => {
          this.setLoading(false)
          this.$message.error(data.msg)
        }
      })
    },
    canceluploadCourseFavorite(courseid, kmctype) {  // 取消收藏
      let ctext = ''
      switch(kmctype.toString()) {
        case '2':
          ctext = '是否需要取消收藏该报告, 是否继续?'
          break;
        case '7':
          ctext = '是否需要取消收藏该课程, 是否继续?'
          break;
        case '8':
          ctext = '是否需要取消收藏该题库, 是否继续?'
          break;
          case '13':
              ctext = '是否需要取消收藏该活动, 是否继续?'
              break;
      }
      this.$confirm(ctext, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.setLoading(true)
          uploadCourseFavorite({
                data: {optype: 0, courseid: courseid, kmctype: kmctype},
                success: data => {
                    this.setLoading(false)
                    if (data.code == '000') {
                      this.$message.success('已取消收藏')

                      // 刷新列表
                      this.getMyCollectlists(1)

                      // 刷新基本信息统计
                      this.$parent.info()

                    } else {
                        this.$message.error(data.msg)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
          })

      }).catch(() => {})
    },
    handleCurrentChange(page) { // 翻页
        this.getMyCollectlists(page)
    },
     gotoRouterDetaills(kmctype, cid) {  // 前往详情页面
      if (kmctype == 8) {
              const { href } = this.$router.resolve({
                name: "QuestionDetails",
                query: {
                    qid: cid
                }
              })
              window.open(href, '_blank');
      } else if (kmctype == 7) {
              const { href } = this.$router.resolve({
                name: "CourseDetails",
                query: {
                    cid: cid
                }
              })
              window.open(href, '_blank');
      } else if (kmctype == 2) {
              const { href } = this.$router.resolve({
                name: "ReportDetails",
                query: {
                    reportid: cid
                }
              })
              window.open(href, '_blank');
      }else if (kmctype == 13) {
          const { href } = this.$router.resolve({
              name: "HdDetails",
              query: {
                  eventid: cid
              }
          })
          window.open(href, '_blank');
      }
    }, 
    ...mapActions(['setLoading'])
  },
  filters: {},
  watch: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" type="text/scss" scope>
.MyCollection {
    .el-menu-demo {
      padding-top: 0;
      padding-bottom: 0;
    }
    .el-menu--horizontal>.el-menu-item {
      color: #333;
      &.is-active {
        color: #409EFF;
      }
    }

}
</style>